import { Tooltip } from "antd";
import React from "react";
import styles from "./tooltip.module.scss";

type Props = {
  text: string;
  children: React.ReactNode;
};

const BridgeTooltip = ({ text, children }: Props) => {
  return (
    <Tooltip
      title={text}
      overlayStyle={{ zIndex: 90000000 }}
      color={styles.tooltipColor}
      showArrow
      overlayInnerStyle={{
        textAlign: "center",
        color: styles.tooltipText,
        fontSize: 14,
      }}
    >
      {children}
    </Tooltip>
  );
};

export default BridgeTooltip;
